/**
 * Top-of-dashboard KPI strip. Five cards mapped from the AnalyticsOverview
 * domain model. `showCompare` is driven by the FiltersBar's "Compare"
 * segment — when off, the deltas are hidden (sparklines stay).
 */
import KpiCard from "../KpiCard/KpiCard";
import {
  formatCount,
  formatPct,
  formatRating,
  formatSec
} from "../../../../../constants/analytics.constants";
import { KpiRowStyles } from "./kpiRow.styles";

const KpiRow = ({ overview, loading = false, showCompare = true }) => {
  const sparks = overview?.sparks || {};
  const items = [
    {
      key: "totalServices",
      label: "Total services",
      value: overview?.totalServices?.value || 0,
      prev: overview?.totalServices?.prev,
      format: formatCount,
      hint: "vs previous period",
      spark: sparks.services
    },
    {
      key: "avgResponseTime",
      label: "Avg response time",
      value: overview?.avgResponseTime?.value || 0,
      prev: overview?.avgResponseTime?.prev,
      format: formatSec,
      hint: "Time from request → accept",
      spark: sparks.response,
      invert: true
    },
    {
      key: "avgRating",
      label: "Avg rating",
      value: overview?.avgRating?.value || 0,
      prev: overview?.avgRating?.prev,
      format: formatRating,
      hint: "Driver star rating",
      suffix: "/5",
      spark: sparks.rating
    },
    {
      key: "completionRate",
      label: "Completion rate",
      value: overview?.completionRate?.value || 0,
      prev: overview?.completionRate?.prev,
      format: formatPct,
      hint: "Finished / total",
      spark: sparks.completion
    },
    {
      key: "uniqueDrivers",
      label: "Unique drivers",
      value: overview?.uniqueDrivers?.value || 0,
      prev: overview?.uniqueDrivers?.prev,
      format: formatCount,
      hint: "Distinct drivers served",
      spark: sparks.drivers
    }
  ];

  return (
    <KpiRowStyles>
      {items.map(it => (
        <KpiCard
          key={it.key}
          label={it.label}
          value={it.value}
          prev={it.prev}
          format={it.format}
          hint={it.hint}
          suffix={it.suffix}
          spark={it.spark}
          invert={it.invert}
          loading={loading}
          showCompare={showCompare}
        />
      ))}
    </KpiRowStyles>
  );
};

export default KpiRow;
